import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { InlineLabel } from '@dealstack/frontend/shared/components/fundament/InlineLabel/InlineLabel';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { ISubItemProps } from '@dealstack/shared/lib/frontend/common-ui/forms';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import { IInlineLabelProps } from '@dealstack/frontend/shared/components/fundament/InlineLabel/InlineLabel.types';

interface Props extends ISubItemProps, IInlineLabelProps {
	className?: string;
	checked?: boolean;
	value: unknown;
	onClick?: () => unknown;
}

const Radio = ({ className, label, labelPlacement, checked, disabled, onClick }: Props) => {
	return (
		<div className={className} onClick={disabled ? undefined : onClick}>
			<InlineLabel disabled={disabled} label={label} labelPlacement={labelPlacement}>
				<Icon variant={checked ? 'radio-checked' : 'radio-unchecked'} />
			</InlineLabel>
		</div>
	);
};

const Memoized = memo(Radio);
const Styled = styled(Memoized)`
	display: flex;
	cursor: pointer;
	justify-content: flex-start;
	align-items: center;
	border-radius: 4px;
	padding: 0.25rem;

	${Icon}.svg {
		--size: 1rem;
		width: var(--size);
		height: var(--size);
		color: ${({ checked, theme }) =>
			checked ? theme.v2.color.secondary[800] : theme.v2.color.neutral[600]};
	}

	${Text} {
		margin-left: 0.75rem;
	}

	${({ theme, disabled }) =>
		disabled
			? css`
					cursor: not-allowed !important;
					${Icon}.svg {
						color: ${theme.v2.color.neutral[400]};
					}
				`
			: ``}

	&:hover {
		background-color: ${({ theme }) => theme.v2.color.secondary[200]};
	}
`;

export { Styled as Radio };
